<div class="swiper">
    <div class="swiper-wrapper">
        <div class="swiper-slide" *ngFor="let annuncio of contentArray">
            <app-card-search-annunci-recenti [annuncioObj]="annuncio" [isHome]="true"
                [showPrice]="true"></app-card-search-annunci-recenti>
        </div>
    </div>
    <!-- Navigation -->
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
</div>
